<app-service-detail>
    <div class="row w-100 m-0 position-relative">
        <app-variables-tabs class="container-fluid px-5"></app-variables-tabs>
        <div 
            *ngFor="let group of items; let i = index;"
            class="col-md-12 px-md-5 ml-auto">
            <app-list-links 
                [items]="group"
                [showSearch]="i === 0 ? true : false"
                headingText="Cross tables available in the service"
                [showHeader]="i === 0 ? true : false"
                (filterValueChange)="i === 0 ? onFilter($event) : false"
                [externalFilter]="i !== 0 ? filterValue : ''">
            </app-list-links>
        </div>
        
    </div>
</app-service-detail>
